import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { CLIENT_ID, USER_POOL_ID } from '../__common/env';
const poolData = {
    UserPoolId: USER_POOL_ID,
    ClientId: CLIENT_ID,
};
let authInstance = null;

export const setAuthInstance = (auth) => {
    authInstance = auth;
};
export const getIdToken = async () => {
    if (authInstance?.isAuthenticated) {
        return authInstance.user?.id_token || authInstance.user?.access_token;
    }
    return new Promise((resolve, reject) => {
        const userPool = new CognitoUserPool(poolData);

        const cognitoUser = userPool.getCurrentUser();

        if (!cognitoUser) {
            reject('No user found');
            return;
        }

        cognitoUser.getSession((err, session) => {
            if (err) {
                reject('Session error');
                return;
            }
            if (!session) {
                reject('No session available');
                return;
            }

            const idToken = session.getIdToken().getJwtToken();
            resolve(idToken);
        });
    });
};
